import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { problems } from '../data/offer';
export function Problems() {
  return <section className="w-full bg-white" aria-labelledby="problems-heading" data-id="element-210" data-mp="36y3rzvvls4gc">
      <div className="mx-auto max-w-5xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-211" data-mp="3237zyvqd9h38">
        <SectionLabel data-id="element-212" data-mp="2y2ecu4kr06be">The reality of living with a problem dog</SectionLabel>

        <h2 id="problems-heading" className="mt-5 max-w-3xl font-display text-[1.6rem] font-semibold leading-[1.15] text-ink sm:mt-6 sm:text-[2.75rem] sm:leading-[1.1]" data-id="element-213" data-mp="2t4w0033m16y4">
          Do you ever feel like your dog owns you, rather than you owning your
          dog?
        </h2>

        <p className="mt-4 font-display text-lg italic text-terracotta sm:mt-5 sm:text-2xl" data-id="element-214" data-mp="2f5d3y8o2pm26">
          How much longer are you willing to guess?
        </p>

        <ul className="mt-9 grid gap-px bg-line sm:mt-12 sm:grid-cols-2" data-id="element-215" data-mp="hch9od4qj6sa">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3.5 bg-white px-4 py-5 sm:gap-4 sm:px-7 sm:py-6" data-id="element-216" data-mp="34qv3glj4cskh">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terracotta-soft" aria-hidden="true" data-id="element-217" data-mp="39rizxmq4a1m3">
                <XIcon className="h-3.5 w-3.5 text-terracotta-dark" data-id="element-218" data-mp="2zsjro599k7zm" />
              </span>
              <span className="text-[15px] leading-relaxed text-ink/80" data-id="element-219" data-mp="3nie3qklrdsit">
                {problem}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 max-w-3xl border-l-2 border-terracotta pl-4 font-display text-lg leading-snug text-ink sm:mt-12 sm:pl-5 sm:text-2xl" data-id="element-220" data-mp="3ep10aoq2j8ih">
          It’s not your fault, and it’s not your dog’s fault. You don’t have a
          “bad dog”—you just don’t have a proven system.
        </p>
      </div>
    </section>;
}